import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-A3-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 29.38 42.28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-A3-logo_svg__cls-1,.svg-A3-logo_svg__cls-2{fill:#00217a;fill-rule:evenodd}.svg-A3-logo_svg__cls-2{fill:#94aacb}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M21.24 21.14h8.14c-4.31-2.08-7.82-5.45-9.98-9.58C15.84 4.73 8.95.83 0 0l.21.6C6.4 2.98 10.69 6.76 13.17 12.1c1.75 3.7 4.56 6.83 8.06 9.04Z",
      class: "svg-A3-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M21.24 21.14h8.14c-4.31 2.08-7.82 5.45-9.98 9.58C15.83 37.55 8.95 41.45 0 42.28l.21-.59c6.19-2.39 10.48-6.16 12.96-11.5 1.75-3.7 4.56-6.83 8.06-9.05Z",
      class: "svg-A3-logo_svg__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M0 6.86c1.48 5.24 3.47 9.59 5.22 11.71.9 1.11 2.08 2 3.44 2.57h6.42c-3.03-1.29-5.46-3.62-6.8-6.51-1.6-3.5-4.58-6.3-8.28-7.77Z",
      class: "svg-A3-logo_svg__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M0 35.42c1.48-5.24 3.47-9.59 5.22-11.71.9-1.11 2.08-2 3.44-2.57h6.42c-3.03 1.29-5.46 3.61-6.8 6.5-1.6 3.5-4.58 6.3-8.28 7.77Z",
      class: "svg-A3-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "A3-logo"}) } }